import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BasicBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";

export const meta: ComponentMeta = {
  name: "Badge List",
  version: 1,
  nameI18n: "builder_ui.block_type.badge_list",
  category: [BasicBlock],
  props: {
    content: {
      name: "Content",
      nameI18n: "builder_ui.prop_type.content",
      prop: "children",
      accepts: ["Basic"],
      type: "children",
    },
  },
};
